<ng-container *ngIf="comboBetPickState">
    <div class="betslip-digital-bet-pick-column-0">
        <bs-digital-pick-selection
            [pick]="pick"
            [selection]="comboBetPickState"
            [betslipType]="betslipType"
            [isLinear]="isLinear$ | async"></bs-digital-pick-selection>
        <bs-digital-combo-prevention-indicator *ngIf="isNotGroup" [pick]="pick" [betslipType]="betslipType"></bs-digital-combo-prevention-indicator>
    </div>
    <div class="betslip-digital-bet-pick-column-1 {{ pickClass }}" (click)="eventClick()">
        <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-pick-odds>
        <ng-container
            *ngTemplateOutlet="
                pickTemplate;
                context: {
                    pick: pick,
                    betslipType: betslipType,
                    messages: messages,
                    showEachWay: comboBetState.isEachWay,
                    hideLineSwitcher: isLinear$ | async,
                    marketLogoTooltipAppendTo: 'bs-betslip-edit-state',
                    marketLogoTooltipBoundaries: 'bs-betslip-edit-state',
                    marketLogoTooltipPlacement: 'bottom-start',
                    marketLogoTrackingLocation: 'betslip',
                }
            "></ng-container>
    </div>
    <div class="betslip-digital-bet-pick-column-2">
        <bs-digital-pick-remove-button
            *ngIf="isRemoveButtonVisible"
            [removeButtonStyle]="removeButtonStyle"
            (remove)="removePick()"></bs-digital-pick-remove-button>
    </div>
    <bs-tabbed-pick-errors *ngIf="!(isLinear$ | async)" [pickId]="pick.id" [betslipType]="betslipType"></bs-tabbed-pick-errors>
</ng-container>
